import React from "react";

import { IconWithBackgroundAttr } from "@multiweb/reactComponents";
import { IconCode } from "@multiweb/types/contracts";
import { PlaceholderComponent } from "../../types";

export const LiteListFrameEncryptedAttributePlaceholder: PlaceholderComponent = ({
    interactive,
}) => (
    <IconWithBackgroundAttr
        iconCode={IconCode.userLock}
        disabled={!interactive}
    />
);
